// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VideoContent_aboveHeader__-EP6y{
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.VideoContent_aboveHeader__-EP6y button{
  cursor: pointer;
  padding: 10px 15px;
}

.VideoContent_addVideoButton__HOT-3 {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #ff3333;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}

.VideoContent_addVideoButton__HOT-3:hover {
  background-color: #ff5252;
  transform: translateY(-2px);
}
.VideoContent_videosContainer__yTILa {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 16px;
}

.VideoContent_videoItem__Hudht {
  position: relative;
  width: 200px;
  border-radius: 8px;
  overflow: hidden;
  background-color: transparent;
  transition: transform 0.2s ease;
}

.VideoContent_videoItem__Hudht:hover {
  transform: scale(1.02);
}

.VideoContent_videoImage__\\+u8g8 {
  width: 100%;
  display: block;
}

/* Play Button styling */
.VideoContent_playButton__WbKsx {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #E50914;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.VideoContent_iconsOverlay__8ldMz {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  z-index: 3;
}

.VideoContent_videoItem__Hudht:hover .VideoContent_iconsOverlay__8ldMz {
  opacity: 1;
  color: #E50914;
}

.VideoContent_icon__tWDB5 {
  background: rgba(255, 255, 255, 0.8);
  padding: 6px;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.3s ease;
}

.VideoContent_icon__tWDB5:hover {
  background: rgba(255, 255, 255, 1);
}

/* Pagination styles */
.VideoContent_pagination__L-PJO {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
}

.VideoContent_paginationButton__1uaY5 {
  background-color: #E50914;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.VideoContent_paginationButton__1uaY5:disabled {
  background-color: #aaa;
  cursor: not-allowed;
}

.VideoContent_paginationButton__1uaY5:hover:not(:disabled) {
  background-color: #b00710;
}

.VideoContent_pageInfo__kvnTy {
  font-weight: 600;
  color: #fff;
  font-size: 14px;
}

/* Modal styles */
.VideoContent_modalOverlay__2pcYw {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.VideoContent_modalContent__Ieer6 {
  background-color: #18181B;
  padding: 20px;
  border: 2px solid #E50914;
  border-radius: 8px;
  text-align: center;
  max-width: 300px;
  width: 90%;
  color: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.VideoContent_modalButtons__rADl4 {
  margin-top: 16px;
  display: flex;
  justify-content: space-around;
}

.VideoContent_modalButton__bkIFq {
  background-color: #E50914;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.VideoContent_modalButton__bkIFq:hover {
  background-color: #b00710;
}
/*Search Bar*/
.VideoContent_searchContainer__RZWVs {
  display: flex;
  align-items: center;
  background: #f1f1f124;
  padding: 5px 10px;
  border-radius: 6px;
  width: 250px;
  color: white;
}

.VideoContent_searchIcon__4VSty {
  color: #666;
}

.VideoContent_searchInput__PEWRC {
  border: none;
  background: transparent;
  padding: 5px;
  outline: none;
  flex: 1 1;
  font-size: 14px;
}
/* Responsive styles */
@media (max-width: 768px) {
  .VideoContent_videoItem__Hudht {
    width: calc(50% - 16px);
  }
  .VideoContent_playButton__WbKsx {
    width: 40px;
    height: 40px;
  }
}

@media (max-width: 480px) {
  .VideoContent_videoItem__Hudht {
    width: 100%;
  }
  .VideoContent_iconsOverlay__8ldMz {
    flex-direction: row;
    top: 4px;
    right: 4px;
  }
  .VideoContent_playButton__WbKsx {
    width: 40px;
    height: 40px;
  }
  .VideoContent_aboveHeader__-EP6y{
    display: block;
    }
  .VideoContent_searchContainer__RZWVs {
    margin-bottom: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/admin/pages/content/CSS/VideoContent.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,2DAA2D;EAC3D,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;EACV,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;AACA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,SAAO;EACP,eAAe;AACjB;AACA,sBAAsB;AACtB;EACE;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,QAAQ;IACR,UAAU;EACZ;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,cAAc;IACd;EACF;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".aboveHeader{\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.aboveHeader button{\n  cursor: pointer;\n  padding: 10px 15px;\n}\n\n.addVideoButton {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #ff3333;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 10px 20px;\n  font-weight: 500;\n  font-size: 15px;\n  cursor: pointer;\n  transition: background-color 0.2s ease, transform 0.1s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n}\n\n.addVideoButton:hover {\n  background-color: #ff5252;\n  transform: translateY(-2px);\n}\n.videosContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  padding: 16px;\n}\n\n.videoItem {\n  position: relative;\n  width: 200px;\n  border-radius: 8px;\n  overflow: hidden;\n  background-color: transparent;\n  transition: transform 0.2s ease;\n}\n\n.videoItem:hover {\n  transform: scale(1.02);\n}\n\n.videoImage {\n  width: 100%;\n  display: block;\n}\n\n/* Play Button styling */\n.playButton {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #E50914;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n}\n\n.iconsOverlay {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out;\n  z-index: 3;\n}\n\n.videoItem:hover .iconsOverlay {\n  opacity: 1;\n  color: #E50914;\n}\n\n.icon {\n  background: rgba(255, 255, 255, 0.8);\n  padding: 6px;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.icon:hover {\n  background: rgba(255, 255, 255, 1);\n}\n\n/* Pagination styles */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.paginationButton {\n  background-color: #E50914;\n  color: #fff;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.paginationButton:disabled {\n  background-color: #aaa;\n  cursor: not-allowed;\n}\n\n.paginationButton:hover:not(:disabled) {\n  background-color: #b00710;\n}\n\n.pageInfo {\n  font-weight: 600;\n  color: #fff;\n  font-size: 14px;\n}\n\n/* Modal styles */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modalContent {\n  background-color: #18181B;\n  padding: 20px;\n  border: 2px solid #E50914;\n  border-radius: 8px;\n  text-align: center;\n  max-width: 300px;\n  width: 90%;\n  color: #fff;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.modalButtons {\n  margin-top: 16px;\n  display: flex;\n  justify-content: space-around;\n}\n\n.modalButton {\n  background-color: #E50914;\n  color: #fff;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.modalButton:hover {\n  background-color: #b00710;\n}\n/*Search Bar*/\n.searchContainer {\n  display: flex;\n  align-items: center;\n  background: #f1f1f124;\n  padding: 5px 10px;\n  border-radius: 6px;\n  width: 250px;\n  color: white;\n}\n\n.searchIcon {\n  color: #666;\n}\n\n.searchInput {\n  border: none;\n  background: transparent;\n  padding: 5px;\n  outline: none;\n  flex: 1;\n  font-size: 14px;\n}\n/* Responsive styles */\n@media (max-width: 768px) {\n  .videoItem {\n    width: calc(50% - 16px);\n  }\n  .playButton {\n    width: 40px;\n    height: 40px;\n  }\n}\n\n@media (max-width: 480px) {\n  .videoItem {\n    width: 100%;\n  }\n  .iconsOverlay {\n    flex-direction: row;\n    top: 4px;\n    right: 4px;\n  }\n  .playButton {\n    width: 40px;\n    height: 40px;\n  }\n  .aboveHeader{\n    display: block;\n    }\n  .searchContainer {\n    margin-bottom: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"aboveHeader": `VideoContent_aboveHeader__-EP6y`,
	"addVideoButton": `VideoContent_addVideoButton__HOT-3`,
	"videosContainer": `VideoContent_videosContainer__yTILa`,
	"videoItem": `VideoContent_videoItem__Hudht`,
	"videoImage": `VideoContent_videoImage__+u8g8`,
	"playButton": `VideoContent_playButton__WbKsx`,
	"iconsOverlay": `VideoContent_iconsOverlay__8ldMz`,
	"icon": `VideoContent_icon__tWDB5`,
	"pagination": `VideoContent_pagination__L-PJO`,
	"paginationButton": `VideoContent_paginationButton__1uaY5`,
	"pageInfo": `VideoContent_pageInfo__kvnTy`,
	"modalOverlay": `VideoContent_modalOverlay__2pcYw`,
	"modalContent": `VideoContent_modalContent__Ieer6`,
	"modalButtons": `VideoContent_modalButtons__rADl4`,
	"modalButton": `VideoContent_modalButton__bkIFq`,
	"searchContainer": `VideoContent_searchContainer__RZWVs`,
	"searchIcon": `VideoContent_searchIcon__4VSty`,
	"searchInput": `VideoContent_searchInput__PEWRC`
};
export default ___CSS_LOADER_EXPORT___;
